module.exports = __webpack_public_path__ + "media/monty-hall.ba2b6cae.mp4";